import { getGrowthChange } from "./growthChange"

const topicTime = v => {
  if (!v) return 0
  const dateMatch = String(v).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (dateMatch) {
    const [, year, month, day] = dateMatch
    return new Date(Number(year), Number(month) - 1, Number(day)).getTime()
  }

  const t = new Date(v).getTime()
  return Number.isNaN(t) ? 0 : t
}

const topicSeoDate = v => {
  if (!v) return ""
  const dateMatch = String(v).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (dateMatch) {
    const [, year, month, day] = dateMatch
    return `${Number(month)}/${Number(day)}/${year}`
  }

  const date = new Date(v)
  if (Number.isNaN(date.getTime())) return ""
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

const topicIsoDate = v => {
  if (!v) return null
  const dateMatch = String(v).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (dateMatch) {
    const [, year, month, day] = dateMatch
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
  }

  const date = new Date(v)
  if (Number.isNaN(date.getTime())) return null
  return date.toISOString().split("T")[0]
}

const topicSheetDateRange = topic => ({
  createdDate: topicIsoDate(topic?.added),
  updatedDate: topicIsoDate(topic?.updated),
})

const topicListUpdatedLabel = (
  topic,
  communities = [],
  communitiesUpdatedOnly = false
) => {
  let bestTime = 0
  let bestRaw = null

  const consider = raw => {
    const t = topicTime(raw)
    if (t > bestTime) {
      bestTime = t
      bestRaw = raw
    }
  }

  if (!communitiesUpdatedOnly && topic) {
    consider(topic.updated)
    consider(topic.added)
  }

  for (const c of communities) {
    consider(c?.updated)
    if (!communitiesUpdatedOnly) {
      consider(c?.added)
    }
  }

  return topicSeoDate(bestRaw)
}

const DEFAULT_TOPIC_SORT = "Communities"
const TOPIC_SORT_OPTIONS = [
  "Communities",
  "Popularity",
  "Growth",
  "Alphabetical",
  "Recent",
  "Updated",
]

const toStatNumber = v => {
  if (v == null || v === "") return 0
  const n = Number(String(v).replace(/,/g, ""))
  return Number.isFinite(n) ? n : 0
}

const topicViewsGrowthPercent = topic => {
  const prev = toStatNumber(topic.viewsWithCommunitiesPrev)
  if (prev <= 0) return null
  return Math.round(
    ((toStatNumber(topic.viewsWithCommunities) - prev) / prev) * 100
  )
}

const formatTopicGrowthChange = (
  topic,
  { onDark = false, wrapped = false } = {}
) => {
  return getGrowthChange(
    topic.viewsWithCommunities,
    topic.viewsWithCommunitiesPrev,
    {
      wrapped,
      onDark,
    }
  )
}

const sortTopics = (sort, topics) => {
  let list = [...topics]
  if (sort === "Popularity") {
    list = list.sort((a, b) =>
      a.visitors < b.visitors ? 1 : b.visitors < a.visitors ? -1 : 0
    )
  } else if (sort === "Growth") {
    list = list.sort((a, b) => {
      const aGrowth = topicViewsGrowthPercent(a)
      const bGrowth = topicViewsGrowthPercent(b)
      if (aGrowth == null && bGrowth == null) return 0
      if (aGrowth == null) return 1
      if (bGrowth == null) return -1
      return aGrowth < bGrowth ? 1 : bGrowth < aGrowth ? -1 : 0
    })
  } else if (sort === "Alphabetical") {
    list = list.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
  } else if (sort === "Communities") {
    list = list.sort((a, b) =>
      a.count < b.count ? 1 : b.count < a.count ? -1 : 0
    )
  } else if (sort === "Recent") {
    list = list.sort((a, b) => topicTime(b.added) - topicTime(a.added))
  } else if (sort === "Updated") {
    list = list.sort((a, b) => topicTime(b.updated) - topicTime(a.updated))
  }
  return list
}

export {
  DEFAULT_TOPIC_SORT,
  TOPIC_SORT_OPTIONS,
  sortTopics,
  formatTopicGrowthChange,
  topicTime,
  topicSeoDate,
  topicIsoDate,
  topicSheetDateRange,
  topicListUpdatedLabel,
}
